import { HaNRoomsMap, HaNWorkspacesMap, isArea, isMeetingRoom, useTabByPathname } from "@organisms";
import { HereAndNowMapsProps } from "./types";
import {
  getIsWorkspacesOnHereAndNowEnabled,
  getMeetingRoomSuggestionByBuildingIdLoadingStatus,
  useAppSelector,
} from "@lib/store";
import { Loader } from "@atoms";
import { Div } from "@quarks";
import { HaNExploreMap } from "./HaNExploreMap";
import { useHereAndNow } from "@pages";

export const HaNMaps = ({
  floorId,
  buildingId,
  onObjectClick,
  viewportRestrictions,
  selectedObject,
  hoverObjectId,
  exploreState,
  onOutsideClick,
}: HereAndNowMapsProps) => {
  const { filterData, tab } = useHereAndNow();

  const isWorkspacesOnHereAndNowEnabled = useAppSelector(getIsWorkspacesOnHereAndNowEnabled);
  const meetingRoomLoadingStatus = useAppSelector(state =>
    getMeetingRoomSuggestionByBuildingIdLoadingStatus(state, buildingId),
  );
  const loadingMeetingRooms = meetingRoomLoadingStatus === "loading" || meetingRoomLoadingStatus === undefined;

  const rooms = filterData.rooms.filteredData;
  const workspaces = filterData.workspaces.filteredData;

  if (loadingMeetingRooms && tab !== "explore") {
    return (
      <Div>
        <Loader />
      </Div>
    );
  }

  if (
    (tab === "rooms" || (!isWorkspacesOnHereAndNowEnabled && !tab)) &&
    (selectedObject === null || isMeetingRoom(selectedObject))
  ) {
    return (
      <HaNRoomsMap
        floorId={floorId}
        buildingId={buildingId}
        onRoomClick={onObjectClick}
        viewportRestrictions={viewportRestrictions}
        selectedRoom={selectedObject && selectedObject.floorId === floorId ? selectedObject : null}
        onOutsideClick={onOutsideClick}
        hoverRoom={rooms!.find(room => room.id === hoverObjectId) || null}
      />
    );
  }

  if (tab === "workspaces" && (selectedObject === null || isArea(selectedObject))) {
    return (
      <HaNWorkspacesMap
        floorId={floorId}
        buildingId={buildingId}
        hoverArea={workspaces.find(area => area.id === hoverObjectId) || null}
        onAreaClick={onObjectClick}
        selectedArea={selectedObject && selectedObject.floorId === floorId ? selectedObject : null}
        onOutsideClick={onOutsideClick}
        viewportRestrictions={viewportRestrictions}
      />
    );
  }

  if (tab === "explore") {
    return (
      <HaNExploreMap
        exploreState={exploreState}
        viewportRestrictions={viewportRestrictions}
        onOutsideClick={onOutsideClick}
      />
    );
  }
};
